<template>
  <div>
    <Head title="Konfigurimi i njoftimeve" />
    <div class="flex justify-start mb-8 max-w-3xl">
      <h1 class="text-3xl font-bold">
        <Link class="text-indigo-400 hover:text-indigo-600">Konfiguro njoftimet</Link>
      </h1>
    </div>
    <h3 class="text-xl font-bold mb-2">Prano njoftimet për:</h3>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">

          <select-input v-model="form.order_success" :error="form.errors.order_success" class="pb-8 pr-6 w-full"
                        label="Dërgesë të suksesshme"
          >
            <option :value="true">Po</option>
            <option :value="false">Jo</option>
          </select-input>

          <select-input v-model="form.order_cancel" :error="form.errors.order_cancel" class="pb-8 pr-6 w-full"
                        label="Dërgesë të anuluar"
          >
            <option :value="true">Po</option>
            <option :value="false">Jo</option>
          </select-input>

          <select-input v-model="form.order_pending" :error="form.errors.order_pending" class="pb-8 pr-6 w-full"
                        label="Dërgesë në pritje"
          >
            <option :value="true">Po</option>
            <option :value="false">Jo</option>
          </select-input>

          <select-input v-model="form.barazim_success" :error="form.errors.barazim_success" class="pb-8 pr-6 w-full"
                        label="Barazim të suksesshëm"
          >
            <option :value="true">Po</option>
            <option :value="false">Jo</option>
          </select-input>

        </div>
        <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Ruaj</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import {Head, Link, usePage} from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import FileInput from '@/Shared/FileInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import {computed} from 'vue'

export default {
  components: {
    FileInput,
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
  },
  layout: Layout,
  props: {
    appNotificationSettings: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        order_success: this.appNotificationSettings.order_success,
        order_cancel: this.appNotificationSettings.order_cancel,
        order_pending: this.appNotificationSettings.order_pending,
        barazim_success: this.appNotificationSettings.barazim_success
      }),
    }
  },
  methods: {
    update() {
      this.form.put(`/konfiguro/njoftimet`)
    },
  },
}
</script>
